import { useCallback, useState } from "react";
import PropTypes from "prop-types";
import "./AuthLayer.scss";
import AuthFooter from "@brand/Auth/AuthFooter";
import { BRANDS } from "app/constants";
import { brandPropTypes } from "app/utils/propTypes";
import SearchBookingContainer from "app/pages/CorporateSite/SearchBooking/SearchBookingContainer";
import Flipper from "app/pages/.shared/Animations/Flipper";
import RecoverBookingDataContainer from "app/pages/CorporateSite/RecoverBookingData/RecoverBookingDataContainer";
import {
	sendTagOnRecoverBookingDataPageLoad,
	sendTagOnSearchBookingPageLoad,
} from "app/utils/analytics";
import IconCrossWhite from "app/pages/.shared/static/icons/IconCrossWhite";
import { AuthTabs } from "app/features/auth/components/authTabs/AuthTabs";

const AuthLayer = ({
	isDefaultSignin,
	onAuthSuccess,
	signinMarketingBlock,
	signupMarketingBlock,
	showMarketingBlock,
	signupFooter,
	signinFooter,
	brand,
	onClose,
}) => {
	const [tab, setTab] = useState(isDefaultSignin ? "login" : "signup");
	const [isSearch, setSearch] = useState(true);

	const handleTabChange = newTab => {
		setTab(newTab);
	};

	const isBrandXX = brand === BRANDS.XX;

	const onClickRecover = useCallback(() => {
		sendTagOnRecoverBookingDataPageLoad();
		setSearch(false);
	}, [isSearch]);

	const onClickCross = useCallback(() => {
		sendTagOnSearchBookingPageLoad();
		setSearch(true);
	}, [isSearch]);

	const renderFrontForm = useCallback(props => {
		return (
			<div {...props}>
				<SearchBookingContainer onClickRecover={onClickRecover} />
			</div>
		);
	}, []);

	const renderBackForm = useCallback(props => {
		return (
			<div {...props}>
				<i className="icon icon--cross" onClick={onClickCross} />
				<RecoverBookingDataContainer onRecoverSuccess={onClickCross} />
			</div>
		);
	}, []);

	return (
		<div className="auth-layer" data-testid="auth-layer">
			{showMarketingBlock && (
				<div className="auth-layer__marketing" data-testid="auth-marketing-text">
					{tab === "signup" ? signupMarketingBlock : signinMarketingBlock}
				</div>
			)}

			{isBrandXX ? (
				<div className="auth-layer__auth-form auth-layer__auth-form--darksite">
					<Flipper
						isFront={isSearch}
						frontComponent={renderFrontForm}
						backComponent={renderBackForm}
					/>
				</div>
			) : (
				<AuthTabs
					onAuthSuccess={onAuthSuccess}
					className="auth-layer__auth-tabs"
					value={tab}
					onValueChange={handleTabChange}
					signupFooter={signupFooter}
					signinFooter={signinFooter}
				/>
			)}
			{onClose && (
				<div className="auth-layer__close-icon" onClick={onClose}>
					<IconCrossWhite />
				</div>
			)}
		</div>
	);
};

AuthLayer.defaultProps = {
	isDefaultSignin: false,
	showMarketingBlock: true,
	signupFooter: <AuthFooter />,
	signinFooter: <AuthFooter />,
};
AuthLayer.propTypes = {
	signupFooter: PropTypes.oneOfType([PropTypes.bool, PropTypes.element]),
	signinFooter: PropTypes.oneOfType([PropTypes.bool, PropTypes.element]),
	isDefaultSignin: PropTypes.bool,
	showMarketingBlock: PropTypes.bool,
	signinMarketingBlock: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	signupMarketingBlock: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	onAuthSuccess: PropTypes.func.isRequired,
	brand: brandPropTypes,
	brandDisplayName: PropTypes.string,
	onClose: PropTypes.func,
};

export default AuthLayer;
